import {
  liveStatsVuexGetters,
} from '@ahaslides-product/frontend-toolkit'
import { isFeatureEnabled, isPresentationCreatedAfterTurnOnFlag } from '../feature-toggles.module'

const _getters = {
  ...liveStatsVuexGetters,
  canUseKvSyncLiveStats: (_, __, ___, rootGetters) => {
    return isPresentationCreatedAfterTurnOnFlag(rootGetters, 'kv-sync-emqx-for-live-stats') &&
      isFeatureEnabled(rootGetters, 'kv-sync-emqx-for-live-stats')
  },
  canSubmitReactionEmqx: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'audience-reaction-emqx')
  },
  canSubscribeReactionEmqx: (_, getters, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'audience-reaction-emqx') &&
      isFeatureEnabled(rootGetters, 'presenter-reaction-emqx') &&
      isPresentationCreatedAfterTurnOnFlag(rootGetters, 'audience-reaction-emqx') &&
      getters.canUseKvSyncLiveStats
  },
}

export default _getters
